import type { MouseEvent } from "react";
import { Button } from "@simplybusiness/mobius";

interface CoversButtonProps {
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
  label?: string;
}
export const CoversButton = (props: CoversButtonProps) => {
  const { onClick, className, label } = props;
  return (
    <Button
      variant="secondary"
      name="see_more_covers_clicked"
      size="md"
      onClick={onClick}
      className={className}
    >
      {label}
    </Button>
  );
};
